// extracted by mini-css-extract-plugin
module.exports = {"imgStyle":"Styles_imgStyle__2fWE8","orgName":"Styles_orgName__3WXj4","orgOverview":"Styles_orgOverview__kSdt0"};